import {
  Button,
  Modal,
} from "react-bootstrap";
import { FaEye, } from "react-icons/fa";
import Typewriter from "typewriter-effect";
import useIcons from "../../../hooks/useIcons";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { AiOutlineClose } from "react-icons/ai";

type AssetDetails = {
  status: number;
  name: string;
  symbol: string;
  type: number;
  country_code: number;
  exchange: string;
  currency_symbol: string;
  encoded_id: string;
  icon: string;
};

type Props = {
  asset_details: AssetDetails;
  ai_insight: string;
  ai_sentiment: number;
  ai_score: number;
  ai_risk_level: number;
};
export default function AssetCard({
  asset_details,
  ai_insight,
  ai_risk_level,
  ai_score,
  ai_sentiment,
}: Props) {
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);

  const { getURI } = useIcons();
  const { push } = useHistory();

  return (
    <div className="project-grid-inner materialized-card h-100">
      <div
        className="d-flex align-items-start cursor-pointer"
        onClick={() => push(`/analysis/${asset_details.encoded_id}`)}
      >
        <div className="d-flex">
          <img
            className="img-xs rounded-circle"
            src={getURI(asset_details.icon)}
          />
          <div className="d-flex flex-column mg-l-10">
            <h5 className="project-title">
              {asset_details.name} ({asset_details.symbol})
            </h5>
            <p className="tx-primary">{asset_details.exchange}</p>
          </div>
        </div>
        {getBadge(asset_details.type)}
      </div>
      <Typewriter
        onInit={(typewriter) => {
          typewriter.typeString(
            getInsightResume(ai_insight) ||
              "Sem resumo disponível, clique abaixo para ver mais detalhes."
          );

          typewriter.start();
        }}
        options={{
          delay: 5,
          cursorClassName: "d-none",
        }}
      />
      <div className="d-flex justify-content-center pd-b-5">
        <Button
          variant="secondary"
          size="sm"
          className="rounded-button"
          onClick={() => setShowDetailsModal(true)}
        >
          Ver insights <FaEye size={20} />
        </Button>

        <Modal
          show={showDetailsModal}
          onHide={() => setShowDetailsModal(false)}
          centered={isMobile}
        >
          <Modal.Header>
            <Modal.Title>
              {asset_details.name} ({asset_details.symbol})
            </Modal.Title>
            <AiOutlineClose
              onClick={() => setShowDetailsModal(false)}
              size={23}
              className="float-right cursor-pointer"
            />
          </Modal.Header>
          <Modal.Body>
            <Typewriter
              onInit={(typewriter) => {
                typewriter.typeString(getAiInsight(ai_insight));

                typewriter.start();
              }}
              options={{
                delay: 1,
                cursorClassName: "d-none",
              }}
            />
          </Modal.Body>
        </Modal>
      </div>
      {getScoreProgressbar(ai_score)}
      {getSentimentListItem(ai_sentiment)}
      {getRiskLevelListItem(ai_risk_level)}
    </div>
  );
}

function getBadge(assetType: number) {
  let backgroundColor = "";
  let text = "";

  switch (assetType) {
    case 1:
      backgroundColor = "#3333ff";
      text = "Ações";
      break;
    case 3:
      backgroundColor = "#cc0000";
      text = "Criptos";
      break;
    case 4:
      backgroundColor = "#009900";
      text = "FIIs";
      break;
    default:
      backgroundColor = "#000000";
      text = "?";
  }

  return (
    <div
      className="badge"
      style={{
        marginLeft: "auto",
        backgroundColor,
        color: "#FFFFFF",
      }}
    >
      {text}
    </div>
  );
}

function extractContentBetweenHeaders(
  html: string,
  startHeader: string,
  endHeader: string
) {
  const regex = new RegExp(`${startHeader}([\\s\\S]*?)${endHeader}`, "i");
  const match = html.match(regex);
  return match ? match[1] : null;
}

function getInsightResume(ai_insight: string) {
  const content = extractContentBetweenHeaders(
    ai_insight,
    "<h2>Ativo x Carteira</h2>",
    "<h2>Pontos Positivos</h2>"
  );

  return content?.trim();
}

function getAiInsight(ai_insight: string) {
  ai_insight = ai_insight.replace(
    "<h2>Ativo x Carteira</h2>",
    "<h3>Relação com sua carteira</h3>"
  );
  ai_insight = ai_insight.replace(
    "<h2>Pontos Positivos</h2>",
    "<h3>Pontos Positivos ✅</h3>"
  );
  ai_insight = ai_insight.replace(
    "<h2>Pontos Negativos</h2>",
    "<h3>Pontos Negativos 🚨</h3>"
  );
  ai_insight = ai_insight.replace(
    "<h2>Pontos de Atenção</h2>",
    "<h3>Pontos de Atenção ⚠️</h3>"
  );

  return ai_insight.trim();
}

function getScoreProgressbar(score: number) {
  let color = "";

  if (score >= 0 && score <= 40) {
    color = "danger";
  } else if (score >= 41 && score <= 69) {
    color = "warning";
  } else if (score >= 70 && score <= 100) {
    color = "success";
  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <p className="mb-2 font-weight-medium">AI Score</p>
        <p className="mb-2 font-weight-medium">{score}</p>
      </div>
      <div className="progress progress-md mb-3">
        <div
          className={`progress-bar bg-${color}`}
          role="progressbar"
          style={{ width: `${score}%` }}
          aria-valuenow={score}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </>
  );
}

function getSentimentListItem(sentiment: number) {
  let color = "";
  let text = "";

  switch (sentiment) {
    case 0:
      color = "danger";
      text = "PESSIMISTA";
      break;
    case 1:
      color = "warning";
      text = "ATENÇÃO";
      break;
    case 2:
      color = "secondary";
      text = "NEUTRO";
      break;
    case 3:
    case 4:
      color = "success";
      text = "OTIMISTA";
      break;
    default:
      color = "secondary";
      text = "NEUTRO";
      break;
  }

  return (
    <div className="az-list-item">
      <div>
        <h6>Sentimento da IA</h6>
        <span>Em relação à sua carteira.</span>
      </div>
      <div>
        <h6 className={`tx-${color}`}>{text}</h6>
      </div>
    </div>
  );
}

function getRiskLevelListItem(riskLevel: number) {
  let color = "";
  let text = "";

  switch (riskLevel) {
    case 0:
      color = "success";
      text = "BAIXO";
      break;
    case 1:
      color = "secondary";
      text = "NEUTRO";
      break;
    case 2:
      color = "danger";
      text = "ALTO";
      break;
    default:
      color = "secondary";
      text = "NEUTRO";
      break;
  }
  return (
    <div className="az-list-item">
      <div>
        <h6>Nível de risco</h6>
        <span>Visando sua carteira e objetivos.</span>
      </div>
      <div>
        <h6 className={`tx-${color}`}>{text}</h6>
      </div>
    </div>
  );
}
